import parsePhoneNumber from 'libphonenumber-js';

// DEFAULT regionCode: 'AU'
const DEFAULT = {
  REGION_CODE: 'AU',
  COUNTRY_CODE: 61
};

export interface PhoneNumberType {
  phoneNumber: string;
  // eslint-disable-next-line no-undef
  regionCode?: object;
}

export const phoneNumberFormatter = ({
  phoneNumber,
  regionCode = { defaultCountry: DEFAULT.REGION_CODE }
}: PhoneNumberType) => {
  // PhoneNumber( '0470000000', 'SE' )
  const ph = parsePhoneNumber(phoneNumber, regionCode);

  if (!ph) {
    return {
      isValid: () => false,
      isMobile: () => false,
      getNumber: () => phoneNumber,
      getDefaultPhoneNumber: () => phoneNumber,
      getInternationalNumberFormat: () => phoneNumber,
      getNationalNumberFormat: () => phoneNumber
    };
  }

  const isValid = () => ph.isValid(); // -> true
  const isMobile = () => ph.getType() === 'MOBILE'; // -> true
  const getNumber = () => ph.number || phoneNumber; // -> '+61470000000'
  const getDefaultPhoneNumber = () => ph.number; // -> '+61470000000' (default)
  const getInternationalNumberFormat = () => ph.formatInternational(); // -> '+61 47 000 00 00'
  const getNationalNumberFormat = () => ph.formatNational(); // -> '047-000 00 00'

  return {
    isValid,
    isMobile,
    getNumber,
    getDefaultPhoneNumber,
    getInternationalNumberFormat,
    getNationalNumberFormat
  };
};
